import { render, staticRenderFns } from "./OrderTabPlanningEntries.vue?vue&type=template&id=1d391caf&scoped=true&"
import script from "./OrderTabPlanningEntries.vue?vue&type=script&lang=ts&"
export * from "./OrderTabPlanningEntries.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d391caf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
